export function initRedact() {
    let modeSwitch = document.getElementById("redactSwitch");
    modeSwitch.checked = isRedacted();
    modeSwitch.onclick = () => {
        let modeSwitch = document.getElementById("redactSwitch");
        if (modeSwitch.checked) {
            localStorage.setItem("redact", "true");
        } else {
            localStorage.setItem("redact", "false");
        }
        cssRedact();
        notifyRedactChanged();
    };
    cssRedact();
    notifyRedactChanged();
    window.addEventListener("storage", (event) => {
        if (event.key === "redact") {
            cssRedact();
            notifyRedactChanged();
        }
    });
}

export function redactCell(cell) {
    cell.classList.add("redactable");
}

function cssRedact() {
    if (isRedacted()) {
        let r = document.querySelector(':root');
        r.style.setProperty('--redact', 'blur(8px)');
    } else {
        let r = document.querySelector(':root');
        r.style.setProperty('--redact', 'none');
    }
}

function notifyRedactChanged() {
    window.dispatchEvent(new CustomEvent("lqos:redact-changed", {
        detail: { redacted: isRedacted() },
    }));
}

export function isRedacted() {
    let prefs = localStorage.getItem("redact");
    if (prefs === null) {
        localStorage.setItem("redact", "false");
        return false;
    }
    if (prefs === "false") {
        return false;
    }
    if (prefs === "true") {
        return true;
    }
}

export function redactText(text) {
    if (!isRedacted()) {
        return text;
    }
    if (text === null || text === undefined) {
        return "";
    }
    return "[redacted]";
}

export function applyRedactFont(label) {
    if (isRedacted() && label) {
        label.fontFamily = "Illegible";
    }
    return label;
}

export function redactLegend(graphOptions) {
    if (isRedacted()) {
        graphOptions.legend.textStyle = {color: "#ccc", backgroundColor: "#ccc"}
    }
}
